import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

const ApplicationId = ({ marginBottom }) => {
  const applicationId = useSelector((state) => get(state, 'workflow.attributes.entityId') || get(state, 'workflow.data.existingApplicationId') || get(state, 'workflow.applicationId'));

  return applicationId ? (
    <div className={`text-sm text-slate-500 mb-${marginBottom} text-center`}>
      Application ID:
      {' '}
      <span className="text-blue-500 font-semibold">
        {applicationId}
      </span>
    </div>
  ) : null;
};

ApplicationId.propTypes = {
  marginBottom: PropTypes.string
};

ApplicationId.defaultProps = {
  marginBottom: '4'
};

export default ApplicationId;
